import { Box, Chevron, Text, Touchable } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import MinutesToText from 'modules/attendance/components/MinutesToText'

export interface Props {
  openAccrued: boolean
  setOpenAccrued: (arg: boolean) => void
  showBreakdown: boolean
  date: moment.Moment
  minutes: number
}

const AccruedSelectedMonth = ({
  openAccrued,
  setOpenAccrued,
  showBreakdown,
  date,
  minutes,
}: Props) => {
  return showBreakdown ? (
    <Touchable onClick={() => setOpenAccrued(!openAccrued)}>
      <Box
        gap="s6"
        alignItems="center"
        flexDirection="row"
        width="full"
        justifyContent="spaceBetween"
      >
        <Box flexDirection="row" alignItems="center" gap="s6">
          <Chevron direction={openAccrued ? 'up' : 'down'} type="terciary" />
          <Text size="300" weight="medium" color="grey1000">
            {i18n.t('clock_in.sidepanel.balance.accrued_since', {
              date: date.format('D MMM, YYYY'),
            })}
          </Text>
        </Box>
        <MinutesToText color="grey1000" value={minutes} size="300" weight="medium" />
      </Box>
    </Touchable>
  ) : (
    <Box
      gap="s6"
      alignItems="center"
      flexDirection="row"
      width="full"
      justifyContent="spaceBetween"
    >
      <Box flexDirection="row" alignItems="center" gap="s6">
        <Text size="300" weight="medium" color="grey1000">
          {i18n.t('clock_in.sidepanel.balance.accrued_since', {
            date: date.format('D MMM, YYYY'),
          })}
        </Text>
      </Box>
      <MinutesToText color="grey1000" value={minutes} size="300" weight="medium" />
    </Box>
  )
}

export default AccruedSelectedMonth
